<!--
 * @Description: 监控列表
-->
<template>
  <div class="w-full h-full">
    <div class="statisticsNum w-full flex flex-wrap py-20px justify-between">
      <div class="flex justify-around items-center w-1/2 cursor-pointer">
        <img :src="device.url" alt="" />
        <div class="text-white">
          <div>
            <!-- <span class="text-20px">{{ device.online }}</span>
            <span>/</span> -->
            <span>{{ device.total }}</span>
            <span>个</span>
          </div>
          <p class="pt-5px">{{ device.name }}</p>
        </div>
      </div>
      <div
        class="
          text-center
          button-bg
          text-white
          h-36px
          leading-36px
          px-20px
          mt-10px
          cursor-pointer
        "
        @click="toNearbyCameras"
      >
        附近监控
      </div>
    </div>
    <div class="mb-10px w-full flex flex-wrap justify-between">
      <!-- <div class="flex justify-around items-center w-1/2">
        <el-select
          v-model="search.status"
          placeholder="状态"
          filterable
          clearable
          class="mr-5px"
          size="mini"
          popper-class="visualization-select-popper"
          @change="searchList"
        >
          <el-option
            v-for="item in statusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div> -->
      <div class="icon-search__input mt-5px mb-5px flex justify-around items-center w-1/2">
        <el-input class="w-full" placeholder="请输入关键词" v-model="search.keyWord" clearable>
          <i slot="append" class="el-icon-search cursor-pointer" @click="searchList"></i>
        </el-input>
      </div>
    </div>
    <el-table
      :data="tableData"
      height="calc(100% - 190px)"
      style="width: 100%"
      @row-click="locationMonitor"
      v-loading="tableLoading"
    >
      <el-table-column type="index" label="序号" width="55"></el-table-column>
      <el-table-column prop="name" show-overflow-tooltip label="摄像头名称"></el-table-column>
      <!-- <el-table-column prop="code" label="状态" width="60">
        <template slot-scope="{ row }">
          <div v-if="row.status === 1" class="successTextColor">在线</div>
          <div v-if="row.status === 2" class="infoText">离线</div>
          <div v-if="row.status === 0" class="infoText">未知</div>
        </template>
      </el-table-column> -->
      <el-table-column label="操作" width="50">
        <template #default="{ row }">
          <div @click.stop="viewDetail(row)" class="cursor-pointer">查看</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      small
      background
      @size-change="getTableData()"
      @current-change="getTableData()"
      :current-page.sync="initPagination.pageNum"
      :page-size.sync="initPagination.pageSize"
      :pager-count="5"
      layout="prev, pager, next"
      :total="initPagination.total"
      class="text-center"
    ></el-pagination>
    <videoDialog
      v-if="videoDialogShow"
      :show.sync="videoDialogShow"
      :code="cameraCode"
      :name="cameraName"
      :pIid="pIid"
      :showControlPanel="true"
      :manufacturerCode="manufacturerCode"
      :daHuaParams="daHuaParams"
    ></videoDialog>
  </div>
</template>

<script>
import { keyBy } from 'lodash'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import { Tag3DPositionApi, Tag3DPositionImgApi } from '@wiz-api/tag-3d-position-management'
import { IOTDeviceApi, Tag3DCameraPositionsApi } from '@wiz-api/iot-device-management'
import { SecurityAlarmRecordApi } from '@wiz-api/security-management'
import videoDialog from '../components/video/videoDialog'

const dataCategoryApi = new DataCategoryApi()
const tag3DPositionManagementAPI = new Tag3DPositionApi()
const tag3DPositionImgApi = new Tag3DPositionImgApi()
const iOTDeviceApi = new IOTDeviceApi()
const tag3DCameraPositionsApi = new Tag3DCameraPositionsApi()
const securityAlarmRecordApi = new SecurityAlarmRecordApi()

export default {
  name: 'cockpit-cameralist',
  props: {
    // 云渲染实例
    player: {
      type: Object,
      defalut: null,
    },
    cloudRender: {
      type: Object,
      defalut: null,
    },
    customProps: {
      type: Object,
      defalut: () => {},
    },
  },
  components: {
    videoDialog,
  },
  data() {
    return {
      device: {
        name: '监控设备',
        total: 243,
        online: 114,
        url: require('../../../assets/images/smartSecurity/监控设备.png'),
        code: 'scameraList',
        codeName: '摄像头列表',
      },
      statusList: [
        {
          label: '在线',
          value: 1,
        },
        {
          label: '离线',
          value: 2,
        },
      ],
      search: {
        status: '',
        keyWord: '',
      },
      initPagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      tableData: [
        // { id: 1, code: '高压缸上部', name: '摄像头1' },
        // { id: 2, code: '中低压缸后部上部', name: '摄像头2' },
        // { id: 3, code: '前轴承箱上部', name: '摄像头3' },
        // { id: 4, code: '高压调节阀1', name: '摄像头4' },
      ],
      markerList: [],
      tableLoading: false,
      manufacturerCode: '', // 厂商
      pIid: '', // 宇视才需要这个pIid
      cameraCode: '',
      cameraName: '',
      videoDialogShow: false,
      deviceTypeList: [],
      basicIconList: [], // 基础图标集合,用于找出该摄像头设置的图标名称
      iconTypeList: [],
      basicImgType: '',
      deviceType: '',
      cameraMarkerList: [], // 三维里需要显示的摄像头集合
      cameraMarkerIds: [],
      textMarkerIds: [],
      posInfo: {
        pos: [],
        code: '',
      },
      markerTableData: [],
      daHuaParams: {}, // 大华参数
    }
  },
  computed: {
    // 驾驶舱配置
    modelSetting() {
      return Wiz.globalSettings.dynamicModules.modules['visualization-cockpit-tongre']?.config
    },
    // 图标的最大可见距离
    maxLod() {
      return this.modelSetting?.cameraDistanceConfig?.maxLod || null
    },
    // 图标的最大可见距离
    minLod() {
      return this.modelSetting?.cameraDistanceConfig?.minLod || null
    },
    isShowMakerText() {
      return this.modelSetting?.cameraListConfig?.isShowMakerText
    },
    headerComponentCode() {
      return this.modelSetting?.headerComponentCode
    },
  },
  watch: {
    cameraMarkerList(val) {
      sessionStorage.setItem('cameraMarkHasShowedList', JSON.stringify(val))
      this.delMarkers()
      this.delTextMarkers()
      this.createCameraMarker()
      const str = sessionStorage.getItem('cameraMarkList')
      if (!this.isShowMakerText) return
      if (Array.isArray(val) && val.length > 0 && !str) {
        val.forEach((item) => {
          this.createTextMakers(item)
        })
      }
    },
  },
  async mounted() {
    this.switchCameraMarker(true)
    this.getCameraCount()
    await this.getDeviceType()
    await this.getCategoryByCodes()
    await this.getBasicIconList()
    // await this.getCamerasHasPosition()
    this.player.Native.ModelTree.EventBrowseLClick.connect(async (info) => {
      this.posInfo.pos = info.pos || []
      this.posInfo.code = info.object.code || ''
    })
    this.player && this.player.Native.GisMarker.EventGisMarkerLClick.connect(this.markerClick)
    this.player && this.player.Native.GisMarker.EventGisMarkerHover.connect(this.markerHover)
  },
  methods: {
    // 关闭/开启摄像头标记
    switchCameraMarker(show) {
      const event = new CustomEvent('setLabelChecked', {
        detail: {
          code: 'CameraList',
          checked: show,
        },
      })
      window.dispatchEvent(event)
    },
    // 附近的摄像头
    toNearbyCameras() {
      if (this.posInfo.pos.length === 0) {
        this.$message.error('请选中模型对象，再使用附近摄像头功能')
        return
      }
      this.delMarkers()
      this.delTextMarkers()
      this.player && this.player.Native.GisMarker.EventGisMarkerLClick.disconnect(this.markerClick)
      this.player && this.player.Native.GisMarker.EventGisMarkerHover.disconnect(this.markerHover)
      sessionStorage.removeItem('cameraMarkHasShowedList')
      this.$emit('transferEvent', {
        toCom: {
          code: 'NearbyCameras',
          origin: 'CameraList',
          name: '监控列表',
        },
        type: 'mainComponent',
        props: this.posInfo,
      })
    },
    // 搜索
    searchList() {
      this.initPagination.pageNum = 1
      this.getTableData()
    },
    // 定位监控
    locationMonitor(row) {
      if (row.threeDAngleView) {
        const cameraParams = JSON.parse(row.threeDAngleView)
        this.cloudRender.Camera.moveCamera('CameraParam', cameraParams)
      }
    },
    // 获取设备类型
    async getDeviceType() {
      const [err, res] = await tag3DPositionManagementAPI.getTag3DPositionTagTypeList()
      if (!err) {
        const deviceTypeList = res || []
        this.deviceTypeList = deviceTypeList
        const queryName = 'IOTDeviceCamera'
        const findItem = deviceTypeList.find((n) => {
          return n.code.includes(queryName)
        })
        this.deviceType = (findItem && findItem.code) || queryName
      }
    },
    // 获取摄像头数量
    async getCameraCount() {
      const [err, res] = await tag3DCameraPositionsApi.getMonitorNumber()
      if (!err) {
        this.device.online = res.online
        this.device.total = res.total
      }
    },
    // 获取已标记的摄像头数据
    async getCamerasHasPosition() {
      const str = sessionStorage.getItem('cameraMarkList')
      if (str && JSON.parse(str).length) {
        return
      }
      const [err, res] = await tag3DCameraPositionsApi.getCamerasHasPosition()
      if (!err) {
        this.markerTableData = res || []
        if (this.player && this.player.Native) {
          this.cameraMarkerList = []
          this.handleCameraData()
        }
      }
    },
    // 监控列表
    async getTableData() {
      this.tableLoading = true
      const [err, res] = await iOTDeviceApi.getDeviceWithDetailPageList({
        ...this.search,
        deviceTypeCode: 'Camera',
        skipCount: (this.initPagination.pageNum - 1) * this.initPagination.pageSize,
        maxResultCount: this.initPagination.pageSize,
      })
      if (!err) {
        this.tableData = res.items || []
        this.initPagination.total = res.totalCount
        await this.getCamerasHasPosition()
      }
      this.tableLoading = false
    },
    // 数据字典获取图标类型
    async getCategoryByCodes() {
      const [err, res] = await dataCategoryApi.getListByCodes({
        codes: ['Tag3DPositionImgType'],
        includeDetails: true,
      })
      if (!err) {
        this.iconTypeList = res[0] && res[0].dataItems
        const findBasicItem = _.find(this.iconTypeList, (item) => {
          return item.code.toLowerCase() === 'base'
        })
        this.basicImgType = findBasicItem && findBasicItem.id
      }
    },
    // 获取基础图标列表
    async getBasicIconList() {
      if (this.basicImgType && this.deviceType) {
        const [err, res] = await tag3DPositionImgApi.findPagedTag3DPositionImgsList({
          imgType: this.basicImgType, // 必传
          tagTypeCode: this.deviceType, // 必传
          skipCount: 0,
          maxResultCount: 1000,
        })
        if (!err) {
          this.basicIconList = res && res.items
          this.getTableData()
        }
      }
    },
    // 获取正在报警摄像头
    async getAlarmList() {
      if (this.headerComponentCode === 'CockpitHeaderDj') return []
      const [err, resulst] = await securityAlarmRecordApi.getDevicePositionWithWarning({
        isPosition: true,
        deviceTypeCode: 'Camera',
        isAlarm: true,
      })
      if (!err && resulst) {
        return resulst
      }
      return []
    },
    async viewDetail(row) {
      this.pIid = row.pIid
      this.cameraCode = row.code || ''
      this.cameraName = row.name || ''
      this.manufacturerCode = row.manufacturerCode || 'Hik'
      this.daHuaParams = {
        id: row.id,
        code: row.code
      }
      this.videoDialogShow = true
      const str = sessionStorage.getItem('cameraMarkList')
      if (str && JSON.parse(str).length) {
        const markList = JSON.parse(str)
        const index = _.findIndex(markList, ['id', row.id])
        if (index > -1) {
          const treeData = await this.player.Native.ModelTree.getRootItems()
          this.player?.Native.Camera.moveToPos(
            JSON.parse(markList[index].threeDPosition),
            treeData[0]?.nodePtr,
            50,
            2
          )
        }
      }
    },
    // 处理监控列表数据显示在三维里
    async handleCameraData() {
      // 获取报警中的数据
      const alarmList = await this.getAlarmList()
      const alarmMap = keyBy(alarmList, 'deviceId')
      const cameras = this.markerTableData.filter((item) => {
        return item.tag3DPositionDto
      })
      const tableDataMap = keyBy(this.tableData, 'id')
      const showMarkerList = cameras
        .filter((item) => { return tableDataMap[item.tag3DPositionRelationKey] })
        .map((item) => {
          return {
            ...item,
            id: item.tag3DPositionRelationKey,
            manufacturerCode: tableDataMap[item.tag3DPositionRelationKey]?.manufacturerCode ?? '',
            isAlarm: alarmMap[item.tag3DPositionRelationKey]?.isAlarm ?? false,
          }
        })
      // 摄像头标记信息
      const cameraMarkerList = showMarkerList.map((camera) => {
        return {
          name: camera.name,
          pos:
            (camera.tag3DPositionDto.threeDPosition &&
              JSON.parse(camera.tag3DPositionDto.threeDPosition)) ||
            [],
          code: camera.code,
          cameraId: camera.tag3DPositionRelationKey,
          tagFileImgId: camera.tag3DPositionDto?.tagFileImgId,
          manufacturerCode: camera.manufacturerCode,
          pIid: camera.pIid,
          isAlarm: camera.isAlarm,
          id: camera.id,
        }
      })
      this.cameraMarkerList = cameraMarkerList
    },
    // 创建摄像头标记
    createCameraMarker() {
      this.cameraMarkerList.forEach(async (camera) => {
        const basicIconInfo = this.basicIconList.find((item) => {
          return item.id === camera.tagFileImgId
        })
        const iconName = basicIconInfo && basicIconInfo.originalFileName
        let backgroundUrl = `data://apps/gat/img/${iconName || 'icon-camara-blue.png'}`
        if (camera.isAlarm) {
          backgroundUrl = 'data://../apps/markers/alarmCamera.png'
        }
        this.player.Native.GisMarker.loadImage(backgroundUrl, (id) => {
          console.log('marker loadImage', id)
          const option = {
            pos: camera.pos, // 定位点，世界坐标，三维向量
            nodeOffset: [0, 0], // 相对定位点的偏移量，二维向量
            imgId: id, // 图片id
            imgSize: [32, 46],
            visible: true,
          }
          if (this.maxLod) option.maxLod = this.maxLod
          if (this.minLod) option.minLod = this.minLod
          this.player.Native.GisMarker.create(option, (markerId) => {
            this.cameraMarkerIds.push({
              markerId,
              type: 'camera',
              code: camera.code,
              name: camera.name,
              cameraId: camera.cameraId,
              manufacturerCode: camera.manufacturerCode,
              pIid: camera.pIid,
              isAlarm: camera.isAlarm,
              id: camera.id
            })
          })
        })
      })
    },
    // 删除图标标记
    delMarkers() {
      if (!this.player || !this.player.Native) return
      _.forEach(this.cameraMarkerIds, (marker) => {
        this.player.Native.GisMarker.destroy(marker.markerId)
      })
      this.cameraMarkerIds = []
    },
    // 删除名称标记
    delTextMarkers() {
      if (!this.player || !this.player.Native) return
      _.forEach(this.textMarkerIds, (marker) => {
        this.player.Native.GisMarker.destroy(marker.markerId)
      })
      this.textMarkerIds = []
    },
    // 创建文本标记
    createTextMakers(item) {
      this.player.Native.GisMarker.loadImage(item.imgBackgroundColor || 'rgba:0,0,0,135', (id) => {
        const nameLength = item.name?.length
        const textRows = Math.ceil((nameLength * 15) / 150)
        const imgHeight = textRows * 15 + 10
        const option = {
          pos: item.pos, // 定位点，世界坐标，三维向量
          nodeOffset: [-40, -30], // 相对定位点的偏移量，二维向量
          imgId: id, // 图片id
          imgSize: [textRows > 1 ? 160 : nameLength * 15, imgHeight || 30],
          text: item.name || '', // 文本
          textFontSize: 15.0, // 字体大小
          breakWidth: 150, // 最大行宽，超过宽度会换行，-1表示限制，换行符（'\n'）会强制换行不受控制
          textColor: 0xffffffff, // 文本颜色
          title: null, // 标题
          contentPadding: [5, 5, 5, 5],
        }
        if (this.maxLod) option.maxLod = this.maxLod
        if (this.minLod) option.minLod = this.minLod
        this.player.Native.GisMarker.create(option, (markerId) => {
          this.textMarkerIds.push({
            markerId,
          })
        })
      })
    },
    // 标记点击
    async markerClick(info) {
      const markerInfo = this.cameraMarkerIds.find((item) => {
        return item.markerId === info.markerId
      })
      // 报警中的摄像头打开预警弹窗
      if (markerInfo?.isAlarm) {
        const [err, res] = await securityAlarmRecordApi.getWarningCard({
          code: markerInfo?.code,
        })
        if (!err && res) {
          this.$emit('transferEvent', {
            toCom: {
              code: 'EarlyWarningDisposalCard',
              origin: 'CameraList',
              name: '预警处置卡',
            },
            type: 'mainComponent',
            props: res,
          })
        }
        return
      }
      if (markerInfo && markerInfo.type === 'camera' && markerInfo.code) {
        this.cameraCode = markerInfo.code || ''
        this.cameraName = markerInfo.name || ''
        this.manufacturerCode = markerInfo.manufacturerCode || 'Hik'
        this.pIid = markerInfo.pIid || ''
        this.daHuaParams = {
          id: markerInfo.id,
          code: markerInfo.code,
        }
        this.videoDialogShow = true
      }
    },
    // 鼠标移入
    markerHover(e) {
      const markerInfo = this.cameraMarkerIds.find((item) => {
        return item.markerId === e.markerId
      })
      if (markerInfo) {
        const val = this.cameraMarkerList.find((item) => {
          return item.cameraId === markerInfo.cameraId
        })
        this.createTextMakers(val)
      } else {
        // 移出删除文本标记
        this.delTextMarkers()
      }
    },
    // 返回初始视角
    backInitPositon() {
      if (this.customProps?.sceneOptions?.jsonData) {
        const jsonData = JSON.parse(this.customProps.sceneOptions.jsonData)
        const cameraParams = jsonData.cameraParams
          ? JSON.parse(jsonData.cameraParams)
          : { eye: [-1028, 580, 13821], target: [-1028, 579, 85], up: [0, 1, 0] }
        // this.cloudRender.Camera.moveCamera('CameraParam', cameraParams)
        this.player.Native.Camera.moveTo(cameraParams.eye, cameraParams.target, cameraParams.up, 2)
      }
    },
  },
  beforeDestroy() {
    this.delMarkers()
    this.delTextMarkers()
    this.backInitPositon()
    this.switchCameraMarker(false)
    this.player && this.player.Native.GisMarker.EventGisMarkerLClick.disconnect(this.markerClick)
    this.player && this.player.Native.GisMarker.EventGisMarkerHover.disconnect(this.markerHover)
    sessionStorage.removeItem('cameraMarkHasShowedList')
  },
}
</script>

<style lang="scss" scoped>
.button-bg {
  background: url('../../../assets/images/button_blue.png');
  background-size: 100% 100%;
}
</style>
